/**
 * Abas da página da integração (AB#87542), guardadas em `?tab=` como as do Brain — o callback
 * do OAuth de um servidor MCP volta direto para `?tab=connection` (AB#87477).
 */
export type IntegrationTab = 'general' | 'connection' | 'tools' | 'usage';

export const INTEGRATION_TABS: readonly IntegrationTab[] = ['general', 'connection', 'tools', 'usage'];

export const DEFAULT_INTEGRATION_TAB: IntegrationTab = 'general';

/** Valor de `?tab=` → aba; desconhecido ou ausente abre a Geral. */
export function resolveIntegrationTab(param: string | null | undefined): IntegrationTab {
  const value = (param ?? '').trim().toLowerCase();
  return (INTEGRATION_TABS as readonly string[]).includes(value)
    ? (value as IntegrationTab)
    : DEFAULT_INTEGRATION_TAB;
}

/** Chave do cache da instância aberta na página — as abas atualizam por ela. */
export const integrationBaseQueryKey = (id: string) => ['integration-base', id] as const;

export function integrationPath(id: string, tab?: IntegrationTab): string {
  return tab && tab !== DEFAULT_INTEGRATION_TAB ? `/integrations/${id}?tab=${tab}` : `/integrations/${id}`;
}

export type OAuthReturn =
  | { status: 'connected' }
  | { status: 'connected_refresh_failed'; message: string | null }
  | { status: 'error'; message: string | null };

/**
 * Retorno do callback OAuth (AB#87477): `?oauth=connected|connected_refresh_failed|error&message=`.
 * `connected_refresh_failed` = autorizou, mas a lista de tools não veio: o que falta é atualizar
 * as tools, e não reautorizar. Qualquer outro valor é ignorado — a página não inventa um
 * resultado que o callback não deu.
 */
export function readOAuthReturn(params: URLSearchParams): OAuthReturn | null {
  const status = params.get('oauth');
  if (status === 'connected') return { status: 'connected' };
  const raw = params.get('message');
  const message = raw && raw.trim() ? raw : null;
  if (status === 'connected_refresh_failed') return { status: 'connected_refresh_failed', message };
  if (status === 'error') return { status: 'error', message };
  return null;
}
